import { Link } from "react-router-dom";

const LectureProgressItem = ({title, to, onClick, className, isCompleted, onToggle,}) => {
  const safeTitle = typeof title === "string"? title.toUpperCase() : "";

  return (
    <li className={className} style={{ cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={isCompleted}
        onClick={(e) => e.stopPropagation()}
        onChange={onToggle || (()=> {})}
      />
      <span className="lecture-text">
        {to ? (
          <Link to={to}>{safeTitle}</Link>
        ) : (
          safeTitle
        )}
      </span>

      {isCompleted}
    </li>
  );
};

export default LectureProgressItem;